// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type LargeArchiveSearchScopeType from "../contract/LargeArchiveSearchScopeType";

export default function largeArchiveSearchScopeType(data: LargeArchiveSearchScopeType): LargeArchiveSearchScopeType {
    const result: LargeArchiveSearchScopeType = {
        __type: "LargeArchiveSearchScopeType:#Exchange",
        ...data,
    };
    
    return result;
}
